export default "__VITE_ASSET__DN$6JUYU__"